import { MessageCollationneTLR } from './message-collationne-tlr.entity';

export class MessageCollationneCreate extends MessageCollationneTLR {
	parcIds!: number[];

	constructor() {
		super();
	}
}